const localeArr = ['en', 'en-us', 'en-gb', 'fi-fi', 'da-dk', 'sv-se', 'no-no', 'de-de', 'en-apac'];

export const hasLocaleInURL = (url, languageArr = localeArr) => {
  const isPreviewURL = url.indexOf(`/editors-only/`) > -1;
  if (isPreviewURL) return false;
  return languageArr.some((lang) => url.indexOf(`/${lang}/`) > -1);
};

export const getLocaleInURL = (url, languageArr = localeArr) => {
  const isPreviewURL = url.indexOf(`/editors-only/`) > -1;
  if (isPreviewURL) return false;
  return languageArr.find((lang) => url.indexOf(`/${lang}/`) > -1);
};
